import React from 'react';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { Story } from '../Stories.types';

interface StoriesListProps {
  list: Story[];
  i18n: Record<string, string>;
  isLoading: boolean;
  isUninitialized: boolean;
}

export const StoriesList = ({ list, i18n, isLoading, isUninitialized }: StoriesListProps) => {
  const firstSection = list.slice(0, 2).map((item, index) => (
    <div className='l-section l-section-50' key={index}>
      <a href={item.ContentLink} className='c-list-block text-within-image'>
        <div className='c-list-block-item'>
          <div className='c-list-block-img'>
            <img loading='lazy' src={item.Image} alt={item.ImageAlt} height='360' width='640' />
          </div>
          <div className='c-list-block-tail'>
            <div className='tail-header'>
              <h3>{item.Title}</h3>
              <i className='icon-angle-right hide-in-mobile' />
            </div>
            <p>{item.Introduction}</p>
          </div>
        </div>
      </a>
    </div>
  ));

  const secondSection = list.slice(2).map((item, index) => (
    <div className='l-section l-section-33' key={index}>
      <a href={item.ContentLink} className='c-list-block'>
        <div className='c-list-block-item'>
          <div className='c-list-block-img'>
            <img src={item.Image} alt={item.ImageAlt} height='360' width='640' />
          </div>
          <div className='c-list-block-tail'>
            <h4>{item.Title}</h4>

            <p>{item.Introduction}</p>
          </div>
        </div>
      </a>
    </div>
  ));

  if (isUninitialized) {
    return <LoadingSpinner />;
  }

  return (
    <section>
      <div className='l-page-center'>
        {list.length == 0 ? (
          i18n.NoResults
        ) : (
          <>
            <div className='l-content'>{firstSection}</div>
            <div className='l-content'>{secondSection}</div>
          </>
        )}
        {isLoading && <LoadingSpinner />}
      </div>
    </section>
  );
};
